<template>
  <v-container class="mx-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card
          flat
          :class="cardClasses"
          v-if="Object.keys(doorphone).length != 0"
        >
          <v-tabs v-model="activeTab" class="selected-tab-custom">
            <template v-for="tab in filterTabs()">
              <template v-if="tab.show && isDisplayInfoDoorphone">
                <v-tab :key="tab.name" class="custom-tab" :disabled="tab.isDisabled">
                  {{ tab.name }}
                </v-tab>
                <v-tab-item :key="tab.name" class="tab-item" :class="{'color-change' : hasFlatCard }">
                  <component v-bind:is="tab.component"/>
                </v-tab-item>
              </template>
            </template>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Keys from '@/components/doorphone/DetailDoorphone/components/Keys';
import DoorOpening from '@/components/doorphone/DetailDoorphone/components/DoorOpening/DoorOpening';
import CallLog from '@/components/doorphone/DetailDoorphone/components/CallLog';
import ListApartments from '@/components/doorphone/DetailDoorphone/components/ListApartments';
import GeneralInfo from '@/components/doorphone/DetailDoorphone/components/GeneralInfo.vue';
import MobileDoorOpening from './components/MobileDoorOpening';
import CodesHistoryDoorphoneTab from './components/CodesHistoryDoorphoneTab.vue';
import actions from './components/actions';

export default {
  name: 'DetailDoorphone',
  props: ['id'],
  data () {
    return {
      disableRoleName: true,
      isDisplayInfoDoorphone: true,
      hasFlatCard: true,
      isDisabled: false,
      activeTab: 0,
    };
  },
  async created () {
    this.isDisplayInfoDoorphone = false;
    this.getDoorphone({
      id: this.id,
    })
      .then(() => {
        this.isDisplayInfoDoorphone = true;
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          this.$flash_danger('Домофон не найден или был удалён');
          this.$router.replace({ name: 'NotFound' });
        } else {
          this.$flash_warning('Ошибка при загрузке информации о домофоне');
        }
      });
  },

  watch: {
    activeTab: {
      handler: function (after, before) {
        this.updateFlatCard();
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters({
      roleName: 'roleName',
      doorphone: 'Doorphone/doorphone',
    }),
    tabs () {
      return [
        {
          name: 'Информация',
          component: GeneralInfo,
          route: 'DetailDoorphoneGeneralInfoNew',
          show: true,
          isDisabled: false,
        },
        {
          name: 'Квартиры',
          component: ListApartments,
          route: 'DetailDoorphoneListApartments',
          show: this.displayTabsAkuvox,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Ключи',
          component: Keys,
          route: 'DetailDoorphoneKeys',
          show: (this.disableRoleName && this.roleName !== 'call-center'),
          isDisabled: this.doorphone.physical_status === 5, // старый домофон,
        },
        {
          name: 'Журнал открытия двери',
          component: DoorOpening,
          route: 'DetailDoorphoneDoorOpening',
          show: this.displayTabsAkuvox,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Журнал звонков',
          component: CallLog,
          route: 'DetailDoorphoneCallLog',
          show: this.displayTabsAkuvox,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Журнал открытия с приложения',
          component: MobileDoorOpening,
          route: 'DetailDoorphoneMobileDoorOpening',
          show: this.disableRoleName,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Журнал кодов',
          component: CodesHistoryDoorphoneTab,
          routes: [
            'DetailDoorphoneTempCodeProvisionHistory',
            'DetailDoorphoneServiceDoorCodeHistory',
          ],
          show: this.disableRoleName,
          isDisabled: false,
        },
        {
          name: 'История активности',
          component: actions,
          route: 'DetailDoorphoneActions',
          show: this.disableRoleName,
          isDisabled: false,
        },
      ];
    },
    cardClasses () {
      return {
        'pb-5': true,
        'border-card': true,
        'color-change': true,
      };
    },
    displayTabsAkuvox (item) {
      return item.doorphone.device.manufacturer !== 'Akuvox';
    },
    isDoorphoneDisabled () {
      // ожидает монтажа и старый домофон
      return this.doorphone.physical_status === 6 || this.doorphone.physical_status === 5;
    },
  },
  methods: {
    ...mapActions({
      getDoorphone: 'Doorphone/getDoorphone',
    }),
    updateFlatCard () {
      this.hasFlatCard = this.activeTab === 0;
    },
    filterTabs () {
      return this.tabs.filter((tab) => {
        if (tab.routes && tab.routes.length) {
          return tab.routes.some((route) => this.$canRoute(route));
        }
        return this.$canRoute(tab.route);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-tab {
  border: 1px solid #C5C9CF;
  border-radius: 16px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.v-tab {
  background-color: #E7E3E3;
}
v-tab:before {
  background-color: #E7E3E3;
  color: black;
}
.v-tab.v-tab--active {
  background-color: white;
  color: black;
}
.color-change {
  background-color: #F5F5F5;
}
.v-tab--active.v-tab:not(:focus) {
  border-radius: 16px;
}
.v-tab--active.v-tab:not(:focus)::before {
  border-radius: 16px;
}
.border-card {
  border-radius: 16px;
}
</style>
